module.exports = __webpack_public_path__ + "img/JapanJingdu.a314eb77.jpg";